export default "__VITE_ASSET__BOWVg$r8__"